export const UserRoleTypes = {
    admin: "SysAdmin",
    poolManager: "PoolManager",
    machineOperator: "MachineOperator"
}

export class UserRole {
    id: string;
    name: string;


    constructor(
        id: string,
        name: string
    ) {
        this.id = id;
        this.name = name;
    }

    static empty(): UserRole {
        return { id: '', name: ''};
    }

}